export const SET_COMPANY_ID = 'SET_COMPANY_ID';
export const SET_IS_ADMIN = 'SET_IS_ADMIN';
export const SET_MOBILE_VIEW = 'SET_MOBILE_VIEW';
export const GET_COMPANY_INFO_REQUEST = 'GET_COMPANY_INFO_REQUEST';
export const GET_COMPANY_INFO_SUCCESS = 'GET_COMPANY_INFO_SUCCESS';
export const GET_BANNER_DATA_REQUEST = 'GET_BANNER_DATA_REQUEST';
export const GET_BANNER_DATA_SUCCESS = 'GET_BANNER_DATA_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const UPDATE_COMPANY_INFO_FAILURE = 'UPDATE_COMPANY_INFO_FAILURE';
export const UPDATE_COMPANY_INFO_SUCCESS = 'UPDATE_COMPANY_INFO_SUCCESS';
export const UPDATE_COMPANY_INFO_REQUEST = 'UPDATE_COMPANY_INFO_REQUEST';
export const GET_SFDC_REQUEST = 'GET_SFDC_REQUEST';
export const GET_SFDC_SUCCESS = 'GET_SFDC_SUCCESS';
export const GET_SFDC_FAILURE = 'GET_SFDC_FAILURE';
export const UPDATE_ACCOUNT_MANAGER_REQUEST = 'UPDATE_ACCOUNT_MANAGER_REQUEST';
export const UPDATE_ACCOUNT_MANAGER_SUCCESS = 'UPDATE_ACCOUNT_MANAGER_SUCCESS';
export const UPDATE_ACCOUNT_MANAGER_FAILURE = 'UPDATE_ACCOUNT_MANAGER_FAILURE';
export const GET_AB_FEATURE_REQUEST = 'GET_AB_FEATURE_REQUEST';
export const GET_AB_FEATURE_SUCCESS = 'GET_AB_FEATURE_SUCCESS';
export const GET_AB_FEATURE_FAILURE = 'GET_AB_FEATURE_FAILURE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const SET_NOTICE_HEIGHT = 'SET_NOTICE_HEIGHT';
export const SET_SHOW_PAGE = 'SET_SHOW_PAGE';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';

export const SET_ENLIGHTEN_MANAGER_TOKEN = 'SET_ENLIGHTEN_MANAGER_TOKEN';
export const GET_IMAGE_BANNER_DATA_REQUEST = 'GET_IMAGE_BANNER_DATA_REQUEST';
export const GET_IMAGE_BANNER_DATA_SUCCESS = 'GET_IMAGE_BANNER_DATA_SUCCESS';

export const GET_APPLICATION_NOTIFICATIONS_REQUEST = 'GET_APPLICATION_NOTIFICATIONS_REQUEST';
export const GET_APPLICATION_NOTIFICATIONS_FAILURE = 'GET_APPLICATION_NOTIFICATIONS_FAILURE';
export const GET_APPLICATION_NOTIFICATIONS_SUCCESS = 'GET_APPLICATION_NOTIFICATIONS_SUCCESS';

export const READ_APPLICATION_NOTIFICATIONS_REQUEST = 'READ_APPLICATION_NOTIFICATIONS_REQUEST';
export const READ_APPLICATION_NOTIFICATIONS_FAILURE = 'READ_APPLICATION_NOTIFICATIONS_FAILURE';

export const MARK_NOTIFICATION_AS_SEEN_REQUEST = 'MARK_NOTIFICATION_AS_SEEN_REQUEST';
export const SET_FROM_LEFT_TAB = 'SET_FROM_LEFT_TAB';

export const GET_APPLICATION_REQUEST = 'GET_APPLICATION_REQUEST';
export const GET_APPLICATION_SUCCESS = 'GET_APPLICATION_SUCCESS';
export const GET_APPLICATION_FAILURE = 'GET_APPLICATION_FAILURE';

export const DELETE_READ_NOTIFICATION_REQUEST = 'DELETE_READ_NOTIFICATION_REQUEST';

export const GET_SOLARGRAF_ACCESS = 'GET_SOLARGRAF_ACCESS';
export const SET_SOLARGRAF_ACCESS_GRANT = 'SET_SOLARGRAF_ACCESS_GRANT';

export const GET_SOLARGRAF_SESSION = 'GET_SOLARGRAF_SESSION';
export const GET_SOLARGRAF_SESSION_SUCCESS = 'GET_SOLARGRAF_SESSION_SUCCESS';

export const VERIFY_SOLARGRAF_SESSION = 'VERIFY_SOLARGRAF_SESSION';

export const VERIFY_SOLARGRAF_EMAIL = 'VERIFY_SOLARGRAF_EMAIL';

export const GET_SOLARGRAF_POPUP_DETAILS_REQUEST = 'GET_SOLARGRAF_POPUP_DETAILS_REQUEST';

export const GET_PROJECT_DETAILS_REQUEST = 'GET_PROJECT_DETAILS_REQUEST';
export const GET_PROJECT_DETAILS_SUCCESS = 'GET_PROJECT_DETAILS_SUCCESS';
export const GET_PROJECT_DETAILS_FAILURE = 'GET_PROJECT_DETAILS_FAILURE';

export const GET_SITE_DETAILS_REQUEST = 'GET_SITE_DETAILS_REQUEST';
export const GET_SITE_DETAILS_SUCCESS = 'GET_SITE_DETAILS_SUCCESS';
export const GET_SITE_DETAILS_FAILURE = 'GET_SITE_DETAILS_FAILURE';

export const CALIFORNIA = 'CA';

export const SET_ITK = 'SET_ITK';

export const SET_COUNTRY = 'SET_COUNTRY';

// for drs left panel integration
export const CAN_APPLY_DRS_FOR_CC_REQUEST = 'CAN_APPLY_DRS_FOR_CC_REQUEST';
export const CAN_APPLY_DRS_FOR_CC_SUCCESS = 'CAN_APPLY_DRS_FOR_CC_SUCCESS';
export const CAN_APPLY_DRS_FOR_CC_FAILURE = 'CAN_APPLY_DRS_FOR_CC_FAILURE';
export const CREATE_DRS_APPLICATION_REQUEST = 'CREATE_DRS_APPLICATION_REQUEST';
export const CREATE_DRS_APPLICATION_SUCCESS = 'CREATE_DRS_APPLICATION_SUCCESS';
export const CREATE_DRS_APPLICATION_FAILURE = 'CREATE_DRS_APPLICATION_FAILURE';
// ends

export const GET_ENLIGHTEN_VERSION_FOOTER = 'GET_ENLIGHTEN_VERSION_FOOTER';
export const SET_ENLIGHTEN_VERSION_FOOTER = 'SET_ENLIGHTEN_VERSION_FOOTER';